module.exports = __webpack_public_path__ + "img/dt_m.233940a0.png";